module.exports = __webpack_public_path__ + "img/zachary-keimig-SpbemGtIg2M-unsplash.fea3ea3d.jpg";